import { testPlainObjectOrPrimitive } from "@ixfx/guards";
import { transform } from "./transform.js";
/**
 * Create a new object from input, based on cloning fields rather than a destructured copy.
 * This is useful for event args.
 * @param source
 * @returns
 */
export const cloneFromFields = (source) => {
    return transform(source, (v) => {
        const entries = [];
        for (const field in v) {
            const value = (v)[field];
            if (testPlainObjectOrPrimitive(value)) {
                entries.push([field, value]);
            }
        }
        return Object.fromEntries(entries);
    });
};
